/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(userComplianceRegistrationId) {
  var defer = $.Deferred();
  $.soap({
    body: {
      GetUserComplianceRegistration: {
        $xmlns: 'http://dobs.pa.gov/sc/usercomplianceregistration/bpm/1.0',
        UserComplianceRegistrationID: userComplianceRegistrationId
      }
    },
    blueprint: {
      userComplianceRegistrationId: '$..ID',
      firstName: '$..FirstName',
      lastName: '$..LastName',
      title: '$..Title',
      professionalTypeID: '$..ProfessionalTypeID',
      organization: '$..Organization',
      addressID: '$..AddressID',
      phone: '$..Phone',
      email: '$..Email',
      specialAccommodations: '$..SpecialAccommodations',
      dietaryRestrictions: '$..DietaryRestrictions',
      paab: '$..PAAB',
      pacleb: '$..PACLEB',
      cfpbos: '$..CFPBOS',
      padoi: '$..PADOI',
      accfc: '$..ACCFC',
      isPaid: '$..IsPaid',
      userID: '$..UserID',
      addressLine1: '$..AddressLine1',
      addressLine2: '$..AddressLine2',
      city: '$..City',
      county: '$..County',
      state: '$..State',
      postalCode: '$..PostalCode',
      country: '$..Country',
      professionalType: '$..ProfessionalType'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
